import React, { useRef, useEffect, useContext } from 'react'
import useState from 'react-usestateref'

import { AnnouncementContext } from '../context/announcementContext'

import styles from './announcement_bar.module.sass'

import classNames from 'classnames'

import Image from '../basic/image'
import Button from '../basic/button'
import Link from '../basic/link'
import { set } from 'lodash'

//get global data
const globalData = JSON.parse(document.getElementById('global-data')?.innerHTML || '{}')

function AnnouncementBar(props) {
	// if(window.location.href.includes('investors.personalis.com')){
	// 	return null
	// }
	// if(!window.location.href.includes('personalis.com') && !window.location.href.includes('pantheonsite.io')){
	// 	return null
	// }

	const announcementBar = useRef(null)
	const [announcements, setAnnouncements] = useState(globalData?.announcements || [])
	const {announcementHeight, heightChangeHandler} = useContext(AnnouncementContext)
	const [enableTakeover, setEnableTakeover] = useState(false)
	const [takeoverIndex, setTakeoverIndex] = useState(null)

	useEffect(() => {
		//if announcements is an empty array, return
		if(!announcements?.length) {
			heightChangeHandler(0)
			return
		}

		//if one of the announcements has enable_takeover set to true, set enableTakeover to true
		const tempTakeoverIndex = announcements.findIndex((announcement) => announcement.fields.enable_takeover)
		setEnableTakeover(tempTakeoverIndex !== -1)
		if(tempTakeoverIndex !== -1) {
			setTakeoverIndex(tempTakeoverIndex)
		}

		let heightTimeout
		if(announcementHeight == 0){
			let timeout = 0
			if(window.location.pathname == '/'){
				timeout = 3000
			}
			
			heightTimeout = setTimeout(() => {
				if (announcementBar.current) {
					heightChangeHandler(announcementBar.current.scrollHeight)
				}
			}, timeout)
		}

		const calculateAnnouncement = () => {
			let container = announcementBar.current.querySelector('.' + styles.ticker_container)
			let containerWidth = container.offsetWidth
			let viewportWidth = window.innerWidth
			let speed = 70

			//if the container is smaller than the viewport, duplicate the .ticker_container container
			if(containerWidth < viewportWidth){
				//duplicate the items inside the container
				let items = container.querySelectorAll('.' + styles.announcement)
				let clonedItems = []
				items.forEach((item) => {
					let clonedItem = item.cloneNode(true)
					clonedItems.push(clonedItem)
				})
				clonedItems.forEach((clonedItem) => {
					container.appendChild(clonedItem)
				})
				calculateAnnouncement()
			}

			let totalDistance = containerWidth + viewportWidth
			let scrollTime = containerWidth / speed

			document.documentElement.style.setProperty('--animation-duration', scrollTime + 's')
			document.documentElement.style.setProperty('--animation-width', (-1 * containerWidth) + 'px')
		}

		//if there is atleast one announcement that is not a takeover, calculate the announcement bar
		if(announcements?.filter((announcement) => !announcement.fields.enable_takeover).length > 0){
			calculateAnnouncement()
		}

		return () => clearTimeout(heightTimeout)
	}, [])


	const handleScroll = () => {
		let scrolledAnnouncementHeight = announcementHeight - document.documentElement.scrollTop
		document.getElementById('announcement_bar').style.maxHeight = (scrolledAnnouncementHeight >= 0 ? scrolledAnnouncementHeight : 0) + 'px'	
		announcementBar.current.classList.add(styles.no_maxheight_transition)
	}

	useEffect(() => {
		window.addEventListener('scroll', handleScroll)
		return () => {
			window.removeEventListener('scroll', handleScroll)
		}
	}), [announcementHeight]

	function closeAnnouncement(){
		announcementBar.current.classList.remove(styles.no_maxheight_transition)

		//find item in document with data-subnav equal to true and set height of header to height of that element
		const subnav = document.querySelector('[data-subnav][expanded=true]')

		if(subnav){
			//subtract announcementHeight from current min-height of header
			const header = document.querySelector('[data-header]')
			header.style.minHeight = (parseInt(header.style.minHeight) - announcementHeight) + 'px'

		}

		heightChangeHandler(0)
	}
	
	function renderAnnouncement(announcement, i){
		
		return <Link key={`announcement_${i}`} url={announcement.fields.link} target={announcement.fields.open_new_window ? '_blank' : ''} className={classNames(styles.announcement, announcement.fields.enable_takeover ? styles.takeover : styles.standard )}>
			{!announcement.fields.enable_takeover && 
				<p className={styles.title}>{announcement?.title}</p>
			}

			{announcement.fields.enable_takeover && 
				<div className={styles.announcement_takeover}>
					<div className={styles.image_wrapper}>
						<Image {...announcement.fields.image} />
					</div>
					<div className={styles.content_wrapper}>
						<h3>{announcement.fields.heading}</h3>
						<div className={styles.product_logo}>
							<Image {...announcement.fields.product_logo} />
						</div>
						<div className={styles.content_flex_wrapper}>
							<div dangerouslySetInnerHTML={{__html: announcement.fields.content}} className={styles.content}></div>
							{announcement.fields.link_text && <Button fields={{url: announcement.fields.link}} appearance='transparent' color='white' className={styles.button}>{announcement.fields.link_text}</Button>}
						</div>
					</div>
				</div>
			}
		</Link>
	}
	
	return <div ref={announcementBar} id="announcement_bar" className={classNames(styles.announcement_bar, props.className)} 
	 style={{maxHeight: window.location.pathname == '/' && announcementHeight + 'px'}}
	>
		{enableTakeover && window.location.pathname == '/' && announcements != null && <div className={styles.announcement_takeover_wrapper}>
				{renderAnnouncement(announcements[takeoverIndex], takeoverIndex)}
				<div className={styles.close_button_wrapper}>
					<div className={styles.close_button} onClick={() => closeAnnouncement()}></div>
				</div>
			</div>
		}
		<div className={styles.announcement_wrapper}>
			{/* if enableTakeover is true, render up to two announcements in the array, otherwise render only the first announcement */}
			<div className={classNames(styles.ticker_container)}>
				{announcements != null && announcements.map((announcement, i) => {
					if(announcement.fields.enable_takeover){return}
					return renderAnnouncement(announcement, i)
				})}
			</div>
			<div className={styles.ticker_container}>
				{announcements != null && announcements.map((announcement, i) => {
					if(announcement.fields.enable_takeover){return}
					return renderAnnouncement(announcement, i)
				})}
			</div>
		</div>
	</div>
}

export default AnnouncementBar